import { createTheme } from '@mui/material';
import { green, grey, lightBlue, orange } from '@mui/material/colors';

let DarkTheme = createTheme({
  palette: {
    mode: 'dark',
    grey: {
      800: '#464646',
    },
  },
  typography: {
    subtitle1: {
      textTransform: 'none',
    },
    fontFamily: ['arial', 'helvetica', 'sans-serif'].join(','),
  },
});

DarkTheme = createTheme(DarkTheme, {
  status: {
    danger: orange[500],
  },
  palette: {
    buttonColor: DarkTheme.palette.augmentColor({
      color: {
        main: '#FFFFFF29',
      },
    }),
    consentButtonColor: DarkTheme.palette.augmentColor({
      color: {
        main: '#141414',
        background: '#D6D6D6',
      },
    }),
    borderColor: DarkTheme.palette.augmentColor({
      color: {
        main: 'rgb(48, 48, 48)',
        // TODO: Change to grey ['800'] when core is killed
      },
    }),
    subHeaderColor: DarkTheme.palette.augmentColor({
      color: {
        main: '#888888',
      },
    }),
    sidebarColor: DarkTheme.palette.augmentColor({
      color: {
        main: '#222222',
      },
    }),
    notStarted: DarkTheme.palette.augmentColor({
      color: {
        main: grey['700'],
      },
    }),
    inProgress: DarkTheme.palette.augmentColor({
      color: {
        main: lightBlue['700'],
      },
    }),
    finished: DarkTheme.palette.augmentColor({
      color: {
        main: green['700'],
      },
    }),
  },
});

export default DarkTheme;
